import useTranslationAvailability from '../hooks/useTranslationAvailability';
export const ShowIfTranslationExists = ({ translationKey, children }) => {
    const { isTranslationAvailable } = useTranslationAvailability();
    if (translationKey === '' || !isTranslationAvailable(translationKey)) {
        return null;
    }
    return children;
};
//# sourceMappingURL=ShowIfTranslationExists.js.map